export default () => ({
  isShow: false,
  showModal: false,
  isShowPrice: false
})



// WEBPACK FOOTER //
// ./src/app/patient/agendas/search/results/components/item/resources/data.js